import { createFileRoute } from "@tanstack/react-router";
import { CompanyAdmin } from "@/components/Companies/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const companyId = params?.id;

  // Force a full remount on navigation between two companies — CompanyAdmin and its
  // sections hold local state (page numbers, expanded rows, sidebar scroll-spy) that
  // must not survive a change to the route's $id param.
  return <CompanyAdmin key={companyId} companyId={companyId} />;
}

export const Route = createFileRoute("/_authenticated/companies/$id/")({
  component: RouteComponent,
  staticData: { page: "companies" },
});
